import { Capacitor, type PluginListenerHandle } from "@capacitor/core";

// Browser events still serve the web and build 79. New shells also receive OS
// connectivity changes while moving between Wi-Fi/cellular or resuming.
export function watchConnectivity(onChange: (online: boolean) => void): () => void {
  let stopped = false;
  let handle: PluginListenerHandle | undefined;
  let revision = 0;
  const publish = (connected: boolean) => { revision++; if (!stopped) onChange(connected); };
  const online = () => publish(true);
  const offline = () => publish(false);
  window.addEventListener("online", online);
  window.addEventListener("offline", offline);
  if (Capacitor.isNativePlatform() && Capacitor.isPluginAvailable("Network")) {
    void (async () => {
      const { Network } = await import("@capacitor/network");
      handle = await Network.addListener("networkStatusChange", status => publish(status.connected));
      if (stopped) { await handle.remove(); return; }
      const before = revision;
      const status = await Network.getStatus();
      if (before === revision && !stopped) publish(status.connected);
    })().catch(() => { /* Browser events remain the fallback. */ });
  }
  return () => {
    stopped = true;
    window.removeEventListener("online", online);
    window.removeEventListener("offline", offline);
    void handle?.remove();
  };
}
